<template>
  <GMapMap :center="center" :zoom="10" map-type-id="terrain" style="width:80rem;height: 85vh;">
    <GMapCluster :zoomOnClick="true">
      <GMapMarker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :draggable="false"
        @click="center = m.position;SelectMarker(m.data)" />
    </GMapCluster>
  </GMapMap>
</template>

<script>
import { store } from "../store/store";

export default {
  props:["markers"],
  data() {
    return {
      center: { lat: 51.093048, lng: 6.84212 },
    };
  },
  methods:{
    SelectMarker(data){
      store.commit({
        type:"UPDATE_CARD_INFO",
        clinic: data.clinic,
        doctor: data.doctor,
        specialization: data.specialization,
        schedule: data.schedule,
        address: data.address,
        phone: data.phone
      })  
    }
  }
};
</script>

<style>
  body {
    margin: 0;
  }
</style>